export default __webpack_public_path__ + "static/media/columns-descending.712d59d4.svg";